import { render, staticRenderFns } from "./change-stamp.vue?vue&type=template&id=203682c4&"
import script from "./change-stamp.vue?vue&type=script&lang=ts&"
export * from "./change-stamp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports